import React from "react";

/**
 * HAVS Guard NT brand wordmark.
 * The "NT" letters sit inside a circular outline as the brand mark.
 *
 * size: "sm" | "md" | "lg" — controls overall text size.
 * tone: "dark" | "light" — light is for use on dark backgrounds.
 */
export default function BrandMark({ size = "md", tone = "dark", className = "" }) {
  const sizeMap = {
    sm: {
      text: "text-sm",
      circle: "h-5 w-5 text-[10px] ml-1.5 border-[1.5px]",
    },
    md: {
      text: "text-lg",
      circle: "h-6 w-6 text-[11px] ml-2 border-2",
    },
    lg: {
      text: "text-xl",
      circle: "h-7 w-7 text-xs ml-2 border-2",
    },
  };

  const { text, circle } = sizeMap[size] || sizeMap.md;
  const colorCls = tone === "light" ? "text-white" : "text-slate-900";

  return (
    <span
      className={`font-display font-bold tracking-tight inline-flex items-center ${text} ${colorCls} ${className}`}
    >
      HAVS Guard
      <span
        className={`inline-flex items-center justify-center rounded-full font-black tracking-tighter border-current ${circle}`}
        aria-hidden="true"
      >
        NT
      </span>
    </span>
  );
}
